import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { downloadURI } from 'utils/downloadDataURI';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimExportWorkOrderChangeAnalyticsAsExcelGql } from '../exportWorkOrderChangeAnalyticsQueries';

const requestId = 'bimExportWorkOrderChangeAnalyticsAsExcel';

export const useBimExportWorkOrderChangeAnalyticsAsExcel = (workOrderChangeId: number, onSuccess: () => void) => {
    const dispatch = useDispatch();
    const [
        bimExportWorkOrderChangeAnalyticsAsExcelData,
        bimExportWorkOrderChangeAnalyticsAsExcelStatus,
        ,
        bimExportWorkOrderChangeAnalyticsAsExcelRequest,
    ] = useRequest({
        requestId,
        query: bimExportWorkOrderChangeAnalyticsAsExcelGql,
        withEffect: false,
    });

    const [bimExportWorkOrderChangeAnalyticsAsExcelReset] = useResetStoreData({ requestId });

    const bimExportWorkOrderChangeAnalyticsAsExcelMakeRequest = useCallback(
        (workOrderVersionId: number) => {
            bimExportWorkOrderChangeAnalyticsAsExcelReset(undefined);

            dispatch(bimExportWorkOrderChangeAnalyticsAsExcelRequest({ workOrderChangeId, workOrderVersionId }));
        },
        [
            bimExportWorkOrderChangeAnalyticsAsExcelRequest,
            bimExportWorkOrderChangeAnalyticsAsExcelReset,
            dispatch,
            workOrderChangeId,
        ],
    );

    useEffect(() => {
        if (
            bimExportWorkOrderChangeAnalyticsAsExcelStatus === RequestStatus.SUCCESS &&
            bimExportWorkOrderChangeAnalyticsAsExcelData?.bimExportWorkOrderChangeAnalyticsAsExcel?.data
        ) {
            const { dataUrl, name } =
                bimExportWorkOrderChangeAnalyticsAsExcelData.bimExportWorkOrderChangeAnalyticsAsExcel.data;

            downloadURI(dataUrl, name);
            bimExportWorkOrderChangeAnalyticsAsExcelReset(undefined);
            onSuccess();
        }
    }, [
        bimExportWorkOrderChangeAnalyticsAsExcelData?.bimExportWorkOrderChangeAnalyticsAsExcel?.data,
        bimExportWorkOrderChangeAnalyticsAsExcelReset,
        bimExportWorkOrderChangeAnalyticsAsExcelStatus,
        onSuccess,
    ]);

    useEffect(() => {
        bimExportWorkOrderChangeAnalyticsAsExcelReset(undefined);
    }, [bimExportWorkOrderChangeAnalyticsAsExcelReset]);

    return {
        bimExportWorkOrderChangeAnalyticsAsExcelMakeRequest,
        bimExportWorkOrderChangeAnalyticsAsExcelStatus,
    };
};
